import { RatesAction } from './actions';
import { RATES_REQUEST_START, RATES_REQUEST_FAIL, RATES_REQUEST_SUCCESS} from './types';

type RatesState = {
  loadingState: string,
  liveRate: string | null
};

const INITIAL_STATE: RatesState = {
  loadingState: 'UNINITIALISED',
  liveRate: null
};

export const reducer = (
  state = INITIAL_STATE,
  action: RatesAction
): RatesState => {
  switch (action.type) {
    case RATES_REQUEST_START:
      return {
        ...state,
        liveRate: null,
        loadingState: 'LOADING'
      };

    case RATES_REQUEST_SUCCESS:
      const liveRate: string = action.payload;

      return {
        ...state,
        liveRate,
        loadingState: 'LOADED'
      };

    case RATES_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'ERROR'
      };

    default:
      return state;
  }
};